export const en = {
  globals: {},
  auth: {
    emailId: "Email Id",
    password: "Password",
    remember: "Remember me",
    forgotPassword: "Forgot Password",
    oldPass: "Old Password",
    confmPas: "Confirm Password",
    otpVerification: "OTP Verification",
    verify: "Verify",
    resendOtp: "Resend Otp",
    login: "Sign In",
    resendPass: "Reset Password",
    editProfile: "Edit Profile",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone Number",
    dontHave: "Don't have an account?",
    signUp: "Sign up",
    already: "Already have an account?",
    enterOtp: "Enter OTP",
    otpSentTo: "An 4 digit OTP has been sent to",
    codeExpire: "code will expire in",
    logout: "Are you sure you want to logout?",
  },
  main: {
    productNameEn: "Product Name( English )",
    productNameAr: "Product Name( Arabic )",
    productNameRu: "Product Name( Russian )",
    gradeEn: "Grade ( English )",
    gradeAr: "Grade ( Arabic )",
    gradeRu: "Grade ( Russian )",
    modelEn: "Modal no. ( English )",
    modelAr: "Modal no. ( Arabic )",
    modelRu: "Modal no. ( Russian )",
    images: "Images",
    editProduct: "Edit Product",
    addProduct: "Add Product",
    deliveryInformation: "Delivery Information",
    instructions: "Instructions",
    orderSummary: "Order Summary",
    orderItems: "Order Items",
    total: "Total",
    item: "Item",
    orderDetails: "Order Details",
    productDesc: "Product Description",
    productType: "Product Type",
    shelfLife: "Self Life",
    modalNumber: "Modal Number",
    grade: "Grade",
    placeOfOrigin: "Place of Origin",
    quantity: "Quantity",
    back: "Back",
    productDetails: "Product Details",
    list: "List",
    addFaq: "Add FAQ",
    answer: "Answer",
    question: "Question",
    arabic: "Arabic",
    english: "English",
    russian: "Russian",
    selectLang: "Select Language",
    addFaq: "Add New FAQ",
    generalSettings: "General Settings",
    faqs: "FAQs",
    query: "Query",
    revertToQuery: "Revert to Query",
    averageDeliveryTime: "Average Delivery Time( Days )",
    responseTime: "Response Time( Hours )",
    helpAndSupport: "Help & Support",
    profileInfo: "profile information",
    broadcast: "Broadcast",
    select: "Select",
    notificationType: "Notification Type",
    sendNotification: "Send Notification",
    addNotification: "Add Notification",
    notificationTable: "Notifications Table",
    averageFeedback: "Average Feedback",
    repeatCustomers: "Repeat Customers",
    respond: "Respond",
    review: "Review",
    customer: "Customer",
    ratings: "Rating & Reviews",
    typeMessage: "Type your message...",
    percentage: "Percentage",
    addDiscount: " Add Discount",
    discountTable: "Discount Table",
    amount: "Amount",
    orderNumber: "Order Number",
    withdraw: "Withdraw Payments",
    paymentHistory: "Payment History",
    extraPaymentByUser: "Extra Payment by User",
    setRefund: "Set Refund",
    setRefundAmount: "Set Refund Amount",
    exchange: "Exchange",
    return: "Return",
    returnTable: "Return & Exchange Table",
    quotesTable: "Quotes Table",
    cancelled: "Cancelled",
    selectDateRange: "Select Date Range",
    ordersTable: "Orders Table",
    send: "Send",
    selectProduct: "Select Product",
    timeFrame: "Time Frame (hours)",
    sendQuotation: "Send Quotation",
    accepted: "Accepted",
    addProducts: "Add Products",
    availableStock: "Available Stock",
    quantityPerUnit: "Quantity per unit",
    pricePerUnit: "Price per unit",
    productsTable: "Products Table",
    rating: "Rating",
    quantitySold: "Quantity Sold",
    products: "Products",
    bestSelling: "Best Selling Products",
    monthlySales: "Monthly Sales",
    commissionPaid: "Commission Paid",
    revenue: "Revenue",
    newOrders: "New Orders",
    pendingQuotes: "Pending Quotes",
    totalCustomers: "Total Customers",
    totalVendors: "Total Vendors",
    totalOrders: "Ongoing Orders",
    completedOrders: "Completed Orders",
    cancelledOrders: "Cancelled Orders",
    totalCategories: "Total Categories",
    totalSubCategories: "Total Sub-Categories",
    totalRevenue: "Total Revenue",
    totalProductsListed: "Total Products Listed",
    exportCsv: "Export Csv",
    sNo: "S.NO",
    image: "Image",
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    email: "Email",
    businessName: "Business Name",
    industryType: "Industry Type",
    address: "Address",
    manageAccount: "Manage Account",
    reject: "Reject",
    accept: "Accept",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    deactivate: "Deactivated",
    search: "Search Here",
    accountStatus: "Account Status",
    actions: "Actions",
    name: "Name",
    subCategory: "Sub-Category",
    addCategory: "Add Category",
    viewSubCategories: "View Sub-Categories",
    selectCategory: "Select Category",
    selectSubCategory: "Select Sub-Category",
    clearFilter: "Clear Filter",
    addProduct: "Add Product",
    productName: "Product Name",
    vendorName: "vendor Name",
    subCategoryName: "Sub-Category Name",
    parentCategory: "Parent Category",
    manageProduct: "Manage Product",
    status: "Status",
    todayDeals: "Today Deals",
    bestDeals: "Best Deals",
    customerName: "Customer Name",
    inProgress: "In Progress",
    category: "Category",
    productQuantity: "Product Quantity",
    price: "Price",
    specificReq: "Specific Requirement",
    chat: "Chat",
    quoteStatus: "Quote Status",
    sendQuote: "Send Quote",
    deliveryConditions: "Delivery Conditions",
    shippingCharge: "Shipping charge",
    freeDelivery: "Free delivery",
    payment: "Payment",
    refundable: "Refundable",
    nonRefundable: "Non-Refundable",
    update: "Update",
    cancel: "Cancel",
    orderId: "Order ID",
    date: "Date",
    refundAmount: "Refund Amount",
    amountSetByVendor: "Amount set by Vendor",
    refund: "Refund",
    refundPayment: "Refund Payment",
    addBanner: "Add Banner",
    banner: "Banner",
    discountName: "Discount Name",
    discountPercentage: "Discount percentage",
    description: "Description",
    type: "Type",
    bannerType: "Banner Type",
    startDate: "Start Date",
    endDate: "End Date",
    addDiscount: "Add Discount",
    onGoing: "On Going",
    completed: "Completed",
    orderTrackId: "Order Track Id",
    userName: "User Name",
    subTotal: "Sub Total",
    totalCost: "Total Cost",
    deliveryFees: "Delivery Fees",
    shippingAddress: "Shipping Address",
    contact: "Contact",
    orderStatus: "Order Status",
    paymentStatus: "Payment Status",
    orderPlaced: "Order Placed",
    shipping: "Shipping",
    delivered: "Delivered",
    extraAmountPay: "Extra Amount to pay",
    totalCostPay: "Total Cost to Pay",
    acceptReject: "Accept/Reject",
    inbox: "Inbox",
    totalPayments: "Total Payments",
    pendingPayments: "Pending Payments",
    amountPaidToVendor: "Amount Paid to Vendor",
    makePayment: "Make Payment",
    pay: "Pay",
    addNotification: "Add Notification",
    sentTo: "Sent To",
    title: "Title",
    messages: "Messages",
    delete: "Delete",
    addSubAdmin: "Add Sub-Admin",
    role: "Role",
    add: "Add",
    platformCommission: "Platform Commission",
    tax: "Tax",
    responseTime: "Response Time (hours)",
    avgDeliveryTime: "Average Delivery time (days)",
    save: "Save",
    orderCancellationTime: "Order Cancellation Time (hours)",
    orderExchangeTime: "Order Exchange Time (days)",
    serviceFee: "Service Fee",
    general: "General",
    timing: "Timing",
    contactSupport: "Contact Support",
    privacyPolicy: "Privacy Policy",
    agreement: "Agreement",
    terms: "Term & Conditions",
    cookiesPolicy: "Cookies Policy",
    about: "About",
    dataDeletion: "Data Deletion Policy",
    conversionRate: "Conversion Rate",
    conversionUsdToAed: "Conversion rate from USD to AED",
    shelfEn: "Shelf Life ( English )",
    shelfAr: "Shelf Life ( Arabic )",
    shelfRu: "Shelf Life ( Russian )",
    styleEn: "Style ( English )",
    styleAr: "Style ( Arabic )",
    styleRu: "Style ( Russian )",
    productTypeEn: "Product Type ( English )",
    producTypeAr: "Product Type ( Arabic )",
    productTypeRu: "Product Type ( Russian )",
    placeOfOrigin: "Place of origin",
    stock: "Available Stock",
    priceUnit: "Price Unit",
    select: "Select",
    makeAsPackage: "Make as Package",
    quantityPerUnit: "Quantity Per Unit",
    pricePerUnit: "Price per unit",
    minPerchaseQty: "Min Purchase Quantity ( in unit )",
    descEng: "Description ( English)",
    descAr: "Description ( Arabic )",
    descRu: "Description ( Russian )",
    bulkPricing: "Bulk Pricing",
    minQty: " Min Quantity",
    maxQty: "Max Quantity",
    remove: "Remove",
    addBulk: "Add Bulk Pricing",
    pricePerKg: "Price per kg",
    pricePerLiter: "Price per Liter",
    minQtyKg: " Min Purchase Quantity ( in Kg )",
    minQtyLiter: "Min Purchase Quantity ( in Liter )",
    selectDateRange: "Select Date Range",
    quotedSubmitted: "Quote submitted",
    quoteNotSubmitted: "Quote not submitted",
    editBanner: "Edit Banner",
    createBannerFor: "Create Banner For",
    discountNameEn: " Discount Name in English",
    discountNameAr: "Discount Name in Arabic",
    discountNameRu: "Discount Name in Russia",
    discountPer: "Discount Percentage",
    addBannerImage: "Add Banner Image",
    orderDetails: "Order Details",
    customerDetails: "Customer Details",
    productsOrdered: "Products ordered",
    regNo: "Registered Number",
    orderedQty: "Ordered Quantity",
    myProfile: "My Profile",
    changePassword: "Change Password",
    logout: "Logout",
    currentPass: "Current Password",
    newPassword: "New Password",
    confirmPass: "Confirm Password",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",
    orders: "Orders",
    sales: "Sales",
    overView: "Overview",
    signToSura: "Sign in to Sura Trade",
    createAccount: "Create an account",
    agree: "Agree to the Sura Trade Agreement",
    profileSetup: " Profile Setup",
    pinCode: "Pin Code",
    city: "City",
    phoneOpt: "Phone Number (Optional)",
    bankDetails: "Bank Details",
    bankName: "Bank Name",
    bankBranch: "Bank Branch",
    holder: "Account Holder's Name",
    accNumber: "Account Number",
    swift: "Swift Code",
    passSetup: "Password Setup",
    enterPass: "Enter Password",
    reEnterPAss: "Re-Enter Password",
    businessReq: "Business registration",
    confirmNewPass: "Confirm New Password",
    submit: "Submit",
    productAdded: "Product Added Successfully",
    productUpdated: "Product Updated Successfully",
    aggrement: "Sura Trade Agreement",
    retailer: "Retailer",
    wholeSaler: "Wholesaler",
    distributor: "Distributor",
    yes: "Yes",
    no: "No",
    checkNewMessage: "Check new messages",
    product: "Product",
    discountUpdated: "Discount Updated Successfully",
    discountAdded: "Discount Added Successfully",
    editDiscount: "Edit Discount",
    discountNameEn: "Discount Name (English)",
    discountNameAr: "Discount Name (Arabic)",
    discountNameRu: "Discount Name (Russian)",
    descEng: "Description ( English)",
    descAr: "Description ( Arabic )",
    descRu: "Description ( Russian )",
    startTime: "Start Time",
    endTime: "End Time",
    cmsUpdated: "CMS updated successfully",
    aboutUs: "About Us",
    terms: "Terms and Conditions",
    privacy: "PrivacyPolicy",
    profileCreated:
      "Profile created successfully! Please wait until admin approves your profile",
    profileUpdate: "Profile update successfully",
    downloadPdf: "Click to download PDF",
  },

  dashboard: {},

  error: {
    required: "This field is required",
    validation1: "Please select a valid video",
    maxValidation: "Maximum 80 character are allowed",
    minValidation: "Minimum 2 characters are required",
    noData: "No results found",
    titlereq: "Title is required",
    descReq: "Description is required",
    noFaq: "No faq's listing found",
    emailReq: "Email is required",
    validEmail: "Enter a valid email address",
    firstReq: "First name is required",
    lastReq: "Last name is required",
    phoneReq: "Phone number is required",
    minPhone: "Phone number must be at least 6 digits",
    maxPhone: "Phone number must be at least 16 digits",
    subAdminCreated: "Sub-admin created successfully",
    subAdminUpdate: "Sub-admin updated successfully",
    userUpdate: "User updated successfully",
    statusUpdate: "Status updated successfully",
    subAdminDel: "Sub-admin deleted successfully",
    userDel: "User deleted successfully",
    max100: "Maximum 100 character are allowed",
    max250: "Maximum 250 character are allowed",
    max500: "Maximum 500 character are allowed",
    catAdd: "Category added successfully",
    catUpdate: "Category updated successfully",
    settingUpdate: "Settings updated successfully",
    faqAdd: "FAQ added successfully",
    faqDel: "FAQ deleted successfully",
    cmsUpdate: "CMS updated successfully",
    messageReq: "Message is required",
    notiAdd: "Notification added successfully",
    notiDel: "Notification deleted successfully",
    logutReq: "Are you sure, you want to logout?",
    noUserFound: "No User Found",
    noVendorFound: "No Vendor Found",
    noSubFound: "No Sub Category Found",
    noChatFound: "No Chats Found",
    categoryReq: "Category is required",
    subCategoryReq: "Sub-Category is required",
    passReq: "Password is required",
    passValid:
      "Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character.",
    passMatch: "Passwords must match.",
    min6: "Minimum 6 characters are required",
    passNotMatch: "Password do not match",
    confirmPassReq: "Confirm Password is required",
    agreeTo: "Please agree to the agreement first",
    uploadImage: "Please Upload Images",
    docReq: "Documents are required",
    areYouSure: "Are you sure to delete this",
    uploadBanner: "Please upload an image for the banner",
    addSettings: "Please add general settings first",
  },
  messages: {},
};
